<template>
    <div class="side-menu-wrapper">
        <transition v-if="overlay" name="fade">
            <div v-if="open" class="side-menu-overlay" :style="{'background':overlay}"></div>
        </transition>

        <transition :name="position">
            <div v-if="open" class="side-menu" :class="{
                    'off-canvas': behavior==='push',
                    'pos-top': position==='top',
                    'pos-right': position==='right'
                }" :style="{
                    'background': background,
                    'max-width': maxWidth
                }">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    import {
        disableBodyScroll,
        enableBodyScroll,
        // clearAllBodyScrollLocks
    } from 'body-scroll-lock';

    Vue.mixin({
        methods: {
            toggleSideMenu(reference) {

                if (!this.$refs[reference].open) {
                    disableBodyScroll(this.$refs[reference], {
                        // paddingRightElements: [document.body, document.querySelector('.header')],
                        reserveScrollBarGap: false,
                    })
                } else {
                    enableBodyScroll(this.$refs[reference], {
                        reserveScrollBarGap: false
                    })
                }

                this.$refs[reference].open = !this.$refs[reference].open;
            },
            closeSideMenu(reference) {
                this.$refs[reference].open = false;

                enableBodyScroll(this.$refs[reference], {
                    reserveScrollBarGap: false
                })
            },
            openSideMenu(reference) {
                this.$refs[reference].open = true;
            }
        }
    })

    export default {
        props: {
            position: {
                type: String,
                required: false,
                default: 'top'
            },
            behavior: {
                type: String,
                required: false,
                default: 'overlay'
            },
            background: {
                type: String,
                required: false,
                default: '#fff'
            },
            maxWidth: {
                type: String,
                required: false,
                default: '100%'
            },
            overlay: {
                type: String,
                required: false,
                default: null
            },
        },
        data() {
            return {
                open: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .side-menu {
        position: fixed;
        display: block;
        height: 100vh;
        width: 100%;
        min-width: 320px;
        z-index: 1100;

        &.pos-top {
            top: 0;
            left: 0;
        }

        &.pos-right {
            right: 0;
            top: 0;
        }

        &.pos-left {
            left: 0;
            top: 0;
        }
    }

    .side-menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        z-index: 1090;
    }

    // Transitions
    .top-enter-active,
    .top-leave-active,
    .right-enter-active,
    .right-leave-active,
    .left-enter-active,
    .left-leave-active {
        transition: transform 500ms ease-out, opacity 750ms ease-out;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 250ms ease-out;
    }

    .top-enter,
    .top-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    }

    .right-enter,
    .right-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }

    .left-enter,
    .left-leave-to {
        transform: translateX(-100%);
        opacity: 0;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>